/* eslint-disable @typescript-eslint/naming-convention */
import * as _ from 'lodash';
import { VehicleDeparture } from './vehicle-departure';

export class VehicleDepartureHistory {
    departures: VehicleDeparture[];

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (this.departures) {
            this.departures = _.map(this.departures, x => new VehicleDeparture(x));
        }
    }
}
